// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "./static/js/" + chunkId + ".1782696929240.js?v=1782696929240";
};